<template>
  <el-dialog
    v-drag:common
    custom-class="city-owner transtant-input"
    :title="title"
    :visible.sync="modal"
    :modal="false"
    width="20%"
    :close-on-click-modal="false"
    :close-on-press-escape="false"
    append-to-body
    center
  >
    <div class="dialog-content-item">
      省市：
      <city-select v-model="cities" :filterable="false"></city-select>
    </div>
    <!-- <div class="dialog-content-item">
      项目：
      <data-select
        filterable
        :loader="getProjectList"
        multiple
        v-model="projects"
      ></data-select>
    </div> -->
    <!-- <div class="dialog-content-item">
      项目：
      <el-input placeholder="请输入项目名称" v-model="projectName"></el-input>
    </div> -->
    <div class="dialog-content-item">
      编号：
      <el-input
        placeholder="请输入测风塔编号,多个可用”，“分开"
        v-model="towerCode"
      ></el-input>
    </div>

    <span slot="footer" class="dialog-footer">
      <el-button @click="cancel">取消</el-button>
      <el-button type="primary" @click="save">搜索</el-button>
    </span>
  </el-dialog>
</template>

<script>
import isEmpty from 'lodash/isEmpty';

export default {
  props: ['title', 'visible'],
  data() {
    return {
      modal: false,
      props: {
        label: 'regionName',
        value: 'com',
        multiple: true
      },
      cities: [],
      // projectName: '',
      towerCode: ''
    };
  },
  watch: {
    modal(val) {
      this.$emit('update:visible', val);
    },
    visible(val) {
      this.modal = val;
    }
  },
  methods: {
    async getProjectList() {
      const res = await this.$fetch('/windfarm/project/getProjectList');
      const projects = res.data.projectList || [];
      return projects.map(item => ({
        value: item.projectName,
        label: item.projectName
      }));
    },
    save() {
      const { cities, projects } = this;
      let adcodes = [];
      if (!isEmpty(cities)) {
        cities.forEach(city => {
          if (city && city[city.length - 1]) {
            const arr = city[city.length - 1].split(',');
            if (arr && arr[1]) {
              adcodes.push(arr[1]);
            }
          }
        });
      }
      console.log('save', { adcodes, projectIds: projects, cities });
      this.$emit('save', {
        address: adcodes.join(','),
        // projectName: this.projectName,
        towerCode: this.towerCode
      });
    },
    cancel() {
      this.$emit('cancel');
    }
  }
};
</script>

<style lang="less">
.city-owner {
  color: #fff;
  /deep/.el-dialog__header {
    text-align: left;
  }
  .dialog-content-item {
    display: flex;
    line-height: 28px;
    padding: 6px;

    .city-select {
      flex: 1;
    }

    .el-input {
      flex: 1;
      input {
        &.el-input__inner {
          color: #000;
        }
      }
    }

    .data-select {
      color: #fff;
      flex: 1;
      .el-select__input {
        color: #fff;
      }
    }
  }
}
</style>
